import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MP',
  name: 'María P.',
  role: 'Docente de Ciencias Naturales — Lima, Perú',
  text: '"Mis alumnos por fin entienden por qué el cambio climático los afecta directamente. Antes yo misma perdía horas buscando ejemplos de nuestra región. Ahora entro al aula con todo listo y con datos reales de nuestro país."'
}, {
  initials: 'CR',
  name: 'Carlos R.',
  role: 'Profesor de Geografía — Bogotá, Colombia',
  text: '"Nunca más llegué a una clase sin saber cómo explicar la diferencia entre mitigación y adaptación o por qué la deforestación en la Amazonía nos afecta a todos. El material hace el trabajo pesado por mí."'
}, {
  initials: 'SV',
  name: 'Sofía V.',
  role: 'Docente de secundaria — Ciudad de México, México',
  text: '"Las planificaciones me ahorran horas. No improviso nunca más frente a mis alumnos cuando hablamos de sostenibilidad, economía circular o huella ecológica."'
}];
export function TestimonialsStrip() {
  return <section className="py-12 bg-white border-y border-dark-border/10" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4" data-id="element-281">
        <div className="grid md:grid-cols-3 gap-6" data-id="element-282">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className="bg-beige-light border border-gold/20 p-6 rounded-2xl relative" data-id="element-283">
              <div className="flex gap-1 text-gold mb-4" data-id="element-284">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-285" />)}
              </div>
              <p className="text-dark/80 italic mb-6 text-sm leading-relaxed" data-id="element-286">
                {t.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-287">
                <div className="w-10 h-10 rounded-full bg-green-light border border-green-medium flex items-center justify-center text-green-dark font-bold" data-id="element-288">
                  {t.initials}
                </div>
                <div data-id="element-289">
                  <div className="font-bold text-green-dark text-sm" data-id="element-290">
                    {t.name}
                  </div>
                  <div className="text-xs text-green-medium" data-id="element-291">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}